export default __webpack_public_path__ + "static/media/961.669832a2.png";